import { Box, Card, CardContent, Typography, Button, Grid, Chip } from '@mui/material';
import { Download, Print, CheckCircle } from '@mui/icons-material';
import { reporteRenta } from '../billingData';

const ReportRenta = () => {
  const data = reporteRenta;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Declaración de Renta - F11
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Formulario de Declaración de Impuesto sobre la Renta
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Chip icon={<CheckCircle />} label="Presentado" color="success" />
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar PDF
          </Button>
        </Box>
      </Box>

      {/* Periodo */}
      <Card sx={{ mb: 3, backgroundColor: '#e8eaf6' }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="h4" color="primary">
            Ejercicio Fiscal {data.periodo}
          </Typography>
        </CardContent>
      </Card>

      <Grid container spacing={3}>
        {/* Ingresos */}
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #388e3c', pb: 1, color: '#388e3c' }}>
                INGRESOS
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Ventas Netas</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ingresos.ventas.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Otros Ingresos</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ingresos.otros.toLocaleString()}</Typography>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #388e3c' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL INGRESOS</Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.ingresos.total.toLocaleString()}</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Costos */}
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #d32f2f', pb: 1, color: '#d32f2f' }}>
                COSTOS
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Inventario Inicial</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.costos.inventarioInicial.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>(+) Compras</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.costos.compras.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'success.main' }}>
                  <Typography>(-) Inventario Final</Typography>
                  <Typography sx={{ fontWeight: 500 }}>(${data.costos.inventarioFinal.toLocaleString()})</Typography>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #d32f2f' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>COSTO VENTAS</Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.costos.total.toLocaleString()}</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Gastos */}
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #f57c00', pb: 1, color: '#f57c00' }}>
                GASTOS
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Salarios</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.gastos.salaries.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Servicios</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.gastos.servicios.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Depreciación</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.gastos.depreciacion.toLocaleString()}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Otros Gastos</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.gastos.otros.toLocaleString()}</Typography>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #f57c00' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL GASTOS</Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.gastos.total.toLocaleString()}</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Resumen */}
        <Grid item xs={12}>
          <Card sx={{ backgroundColor: '#fce4ec' }}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>Renta Imponible</Typography>
                    <Typography sx={{ fontWeight: 600 }}>${data.rentaImponible.toLocaleString()}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>Impuesto (25%)</Typography>
                    <Typography sx={{ fontWeight: 600 }}>${data.impuesto.toLocaleString()}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>ISR A PAGAR</Typography>
                    <Typography variant="h5" color="error.main" sx={{ fontWeight: 700 }}>${data.impuesto.toLocaleString()}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Declaración de Renta - Formulario F11
          </Typography>
          <Typography variant="body2">
            El formulario F11 es utilizado para declarar el Impuesto sobre la Renta (ISR) de personas jurídicas. 
            Se calcula como el 25% de la renta imponible (ingresos menos costos y gastos deducibles).
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportRenta;
